import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const usePreventNavigation = (route:string) => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams()

  useEffect(() => {
    // Substitui o estado atual no histórico para limpar o histórico anterior
    // Adiciona um novo estado ao histórico para evitar voltar à página anterior
    window.history.pushState(null, "", window.location.pathname);

    const handlePopState = () => {
      // Redireciona para a página inicial caso o usuário tente voltar
      window.history.pushState(null, "", window.location.pathname);
      navigate(route, { replace: true });
    };

    // Adiciona o evento para monitorar o botão "Voltar"
    window.addEventListener("popstate", handlePopState);

  }, [navigate, pluginspace_id]);

}



export default usePreventNavigation;